import { opsApi } from "common/api";


export async function getPosHar(operationId: string) {
    const regionRes = await opsApi.fetch(`/instrumentation/pos/httparchive?operation=${operationId}`);

    return (await regionRes.json()) as {};
}